<div class="card-component">
  <kendo-grid #grid [kendoGridBinding]="gridView">

    <kendo-grid-column field="tipo" [title]="customMsgService.translate('tipo')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.nomeTipo }} </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="valor" [title]="customMsgService.translate('valor')" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.valor }} </div>
      </ng-template>
    </kendo-grid-column>

  </kendo-grid>
</div>